document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".testimonial-wrapper");
  const slides = document.querySelectorAll(".testimonial-slide");
  const nav = document.querySelector(".testimonial-nav");
  const prevBtn = document.querySelector(".testimonial-nav .prev");
  const nextBtn = document.querySelector(".testimonial-nav .next");
  const dotsContainer = document.querySelector(".testimonial-dots");
let dots = [];


  if (!slides.length || !nav) return;

  let index = 0;
  let startX = 0;

  // Hide nav if only one slide
  if (slides.length <= 1) {
    nav.style.display = "none";
    slides[0].classList.add("active");
    return;
  }

  // Create dots (mobile)
if (dotsContainer) {
  slides.forEach((_, i) => {
    const dot = document.createElement("span");
    dot.classList.add("testimonial-dot");

    if (i === 0) dot.classList.add("active");

   dot.addEventListener("click", () => {
  const direction = i > index ? "next" : "prev";
  index = i;
  updateSlides(direction);
});


    dotsContainer.appendChild(dot);
    dots.push(dot);
  });
}


  nav.style.display = "flex";

  function updateSlides(direction = "next") {
  slides.forEach((slide, i) => {
    slide.classList.remove("active", "from-left", "from-right");

    if (i === index) {
      slide.classList.add("active");
    } else {
      slide.classList.add(direction === "next" ? "from-right" : "from-left");
    }
  });

  // 🔵 Update dots
  if (dots.length) {
    dots.forEach(dot => dot.classList.remove("active"));
    dots[index].classList.add("active");
  }

  // Disable buttons at edges
  prevBtn.disabled = index === 0;
  nextBtn.disabled = index === slides.length - 1;

  prevBtn.classList.toggle("disabled", index === 0);
  nextBtn.classList.toggle("disabled", index === slides.length - 1);
}

  nextBtn.addEventListener("click", () => {
    if (index < slides.length - 1) {
      index++;
      updateSlides("next");
    }
  });

  prevBtn.addEventListener("click", () => {
    if (index > 0) {
      index--;
      updateSlides("prev");
    }
  });

  /* 👉 SWIPE SUPPORT */
  slider.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  slider.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;

    if (Math.abs(diff) < 50) return;

    if (diff > 0 && index < slides.length - 1) {
      index++;
      updateSlides("next");
    } else if (diff < 0 && index > 0) {
      index--;
      updateSlides("prev");
    }
  });

  /* 👉 AUTO SLIDE EVERY 3 SECONDS */
let autoSlide = setInterval(() => {
  if (index < slides.length - 1) {
    index++;
    updateSlides("next");
  } else {
    index = 0; // restart from first slide
    updateSlides("next");
  }
}, 3000);

  // Init
  updateSlides();
});
